import Navbar from '../../components/feature/Navbar';
import RegistrationHeader from './components/RegistrationHeader';
import PricingTable from './components/PricingTable';
import IncludedServices from './components/IncludedServices';
import CancellationPolicy from './components/CancellationPolicy';

export default function RegistrationPage() {
  return (
    <>
      <title>Kayıt & Ücretler | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 kayıt bilgileri ve katılım ücretleri. Genç Diş Hekimliği Derneği 2. Ulusal Kongresi için erken kayıt avantajlarından yararlanın. 2-3 Mayıs 2026, İstanbul." />
      <meta name="keywords" content="istanbul dental kongresi kayıt, dental kongre 2026 ücret, diş hekimliği kongresi kayıt ücreti" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/kayit" />
      <meta property="og:title" content="Kayıt & Ücretler | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="2. Ulusal İstanbul Dental Kongresi kayıt bilgileri ve katılım ücretleri. Erken kayıt avantajlarından yararlanın." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/kayit" />
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
        <Navbar />
        <RegistrationHeader />
        <PricingTable />
        <IncludedServices />
        <CancellationPolicy />
      </div>
    </>
  );
}
